import React from 'react';
import PropTypes from 'prop-types';

export function ViewControlsBar({ left = null, right = null, children }) {
  return (
    <div className="onyx-view-controls" data-testid="onyx-view-controls">
      {left}
      {children}
      <div className="onyx-view-controls__spacer" />
      {right ? <div className="onyx-view-controls__right">{right}</div> : null}
    </div>
  );
}

ViewControlsBar.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  children: PropTypes.node,
};
